<template>
  <div class="home">
    <div
      class=" flex flex-col sticky z-10 shadow bg-white mb-12 w-full"
      style="top: 50px"
    >
      <div class="flex px-8 items-center py-4 mb-4 justify-between">
        <div class="page-heading text-2xl font-semibold">
          Course Prerequiste
        </div>
      </div>
    </div>
    <div class="px-8 ">
      <div class="mx-4 my-4">
        <div class="mx-8 mt-4">
          <linput
            v-model="search"
            class="py-2"
            placeholder="Search by Instructor Name"
          />
        </div>
      </div>
      <table v-if="filteredRecords.length > 0" class="table-auto w-full">
        <thead>
          <tr class="">
            <th class="px-4 py-1 text-left">S/N</th>
            <th class="w-5/12 px-4 py-1 text-center">Target</th>
            <th class="w-5/12 px-4 py-1 text-left">Prerequisite</th>
            <th class="w-2/12 px-4 py-1 text-left">Type</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="(x, index) in filteredRecords" :key="index">
            <td class="px-4 border-b py-5 text-left">{{ index + 1 }}</td>
            <td class="px-4 border-b py-5 text-left">
              {{ x.target.title }}
            </td>
            <td class="px-4 border-b py-5 text-left">
              {{ x.prerequiste.title }}
            </td>
            <td class="px-4 border-b py-5 text-left">
              {{ x.target_type }}
            </td>
            <td class="px-4 border-b py-5 text-left">
              <a @click="deleteData(x.id)" class="text-red-600" href="#"
                >Delete</a
              >
            </td>
          </tr>
        </tbody>
      </table>
      <div class="text-center text-2xl font-semibold text-black" v-else>
        <empty message="No Prerequiste created" />
      </div>
    </div>
  </div>
</template>
<script>
import { mapActions, mapMutations } from "vuex";
import Empty from "../../../components/general/Empty";
export default {
  data() {
    return {
      quickSearch: "",
      list: [],
      search: "",
      selected: "",
    };
  },
  computed: {
    filteredRecords() {
      let data = this.list.filter((row) => {
        return Object.keys(row).some((key) => {
          return (
            String(row[key])
              .toLowerCase()
              .indexOf(this.search.toLowerCase()) > -1
          );
        });
      });

      return data;
    },
  },
  components: {
    Empty,
    card: () => import("@/components/tenant/reward-card"),
    lbutton: () => import("@/components/general/button"),
    linput: () => import("@/components/general/input"),
  },
  methods: {
    ...mapMutations(["updateLoader"]),
    ...mapActions(["tenantAllPrequisites", "tenantDeletePrerequisite"]),
    deleteData(id) {
      this.selected = id;
      this.handleClick();
    },
    async loadData() {
      this.updateLoader(true);
      let res = await this.tenantAllPrequisites();
      this.list = res.data.data.prequisites;
      this.updateLoader(false);
    },
    async deletePrerequisite() {
      this.updateLoader(true);
      let res = await this.tenantDeletePrerequisite({ id: this.selected });
      this.updateLoader(false);
      if (res) {
        this.loadData();
        this.$Bus.$emit("notify", {
          type: "success",
          message: "Prerequisite deleted succesfully",
        });
      } else {
        this.$Bus.$emit("notify", {
          type: "error",
          message: res.data.errors
            ? res.data.errors[0].title
            : "An error occured",
        });
      }
    },
    handleClick() {
      this.$confirm({
        message: `Are you sure you want to delete this Prerequisite?`,
        button: {
          no: "No",
          yes: "Yes",
        },

        callback: (confirm) => {
          if (confirm) {
            this.deletePrerequisite();
          }
        },
      });
    },
  },
  async mounted() {
    this.loadData();
  },
};
</script>
